<template>

  <router-link :to="link"
               :class="[{ active: $route.path.includes(routeGlobal)}]">

    <div class="icon-w">
      <i :class="icon"/>
    </div>
    <span>{{ name }}</span>
  </router-link>
</template>
<script>

export default {
	name: 'menu-item',
	props: {
		name: {
			type: String,
			required: true,
			default:null
		},
		icon: {
			type: String,
			required: true,
			default:null
		},
		link: {
			type: String,
			required: true,
			default:null
		},
		routeGlobal: {
			type: String,
			required: false,
			default:null
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/subMenu/MenuItem.vue